import React from 'react';
import FeatherIconContainer from '../../Componant/Icons/FeatherIcon';

const FeatherIcon = () => {
  return (
    <div className='page-body'>
      <FeatherIconContainer />
    </div>
  );
};

export default FeatherIcon;
